import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NavbarService } from '../services/behavior/navbar.service';
import { Router } from '@angular/router';

@Injectable()
export class GuidInterceptor implements HttpInterceptor {

  constructor(
    private navbarService: NavbarService, private router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const rota = this.getRouteOnlyLettersAndNumbers(request);
    
    let guid = this.generateGuidFromString('empty-body-request', rota);
    
    if (request.body) {
      if (typeof request.body === 'string') {
        guid = this.generateGuidFromString(request.body, rota);
      } else {
        guid = this.generateGuidFromString(JSON.stringify(request.body), rota);
      }
    }
    
    const clonedRequest = request.clone({
      setHeaders: {
        'x-guid': guid
      }
    });

    return next.handle(clonedRequest);
  }

    getRouteOnlyLettersAndNumbers(request: HttpRequest<unknown>): string {

    const rota = request.urlWithParams;

    return rota.replace(/[^a-zA-Z0-9]/g, '');
  }

  /**
   * Generates a deterministic UUID format string (8-4-4-4-12) based on the string provided.
   */
  private generateGuidFromString(str: string, rota: string): string {
    let hash1 = 5381;
    let hash2 = 52711;
    
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash1 = ((hash1 << 5) + hash1) + char;
      hash2 = ((hash2 << 5) + hash2) ^ char;
    }
    
    const hex1 = Math.abs(hash1).toString(16).padStart(8, '0');
    const hex2 = Math.abs(hash2).toString(16).padStart(8, '0');
    const hex3 = Math.abs(hash1 ^ hash2).toString(16).padStart(8, '0');
    const hex4 = Math.abs(hash1 & hash2).toString(16).padStart(8, '0');
    const hex5 = Math.abs(hash1 | hash2).toString(16).padStart(8, '0');

    // formating into UUID standard structure: 8-4-4-4-12
    //const retorno = `${hex1}-${hex2.substring(0, 4)}-${hex2.substring(4, 8)}-${hex3.substring(0, 4)}-${hex3.substring(4, 8)}${hex4}-${this.navbarService.idSessao}-${rota}`;
    const retorno = `${hex1}-${hex2.substring(0, 4)}-${hex2.substring(4, 8)}-${hex3.substring(0, 4)}-${hex3.substring(4, 8)}${hex4}-${this.navbarService.idSessao}-${rota}`;
    
    return retorno;
  }
}
